import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { AxiosError } from 'axios';
import styled from 'styled-components';
import { Loader, SdirButton } from '@sdir/sds';
import { useApi } from '@sdir/httpclient/lib/hooks/useApi';
import { ErrorMessage } from '@sdir/utilities/lib/components';
import { educatiaApi } from '../../../httpclient';

type MyEducatiaProps = {
  hideExisting?: boolean;
  hideTitle?: boolean;
};

export const MyEducatia: React.FC<MyEducatiaProps> = ({
  hideExisting = false,
  hideTitle = false,
}) => {
  const intl = useIntl();
  const [submitError, setSubmitError] = useState<AxiosError>();

  const {
    result: examsResult,
    loading: examsLoading,
    callApi: getExams,
  } = useApi({
    apiFunction: () => educatiaApi.v1EducatiaGetsrcexamGet(),
    callApiOnInit: true,
  });

  const onOpenExistingExam = () => {
    if (examsResult?.url) {
      window.open(examsResult.url, '_blank', 'noopener,noreferrer');
    }
  };

  const onNewExam = () => {
    setSubmitError(undefined);
    const popup = window.open('', '_blank');
    educatiaApi
      .v1EducatiaPostsrcexamaccessPost()
      .then((result) => {
        getExams?.();
        const url = result?.data?.url;
        if (url && popup) {
          popup.location.href = url;
        } else {
          popup?.close();
        }
      })
      .catch((err) => {
        popup?.close();
        setSubmitError(err);
      });
  };

  return (
    <Wrapper>
      {!hideTitle && <h2>{intl.formatMessage({ id: 'competenceDashboard.educatia.title' })}</h2>}
      {examsLoading && (
        <FeedbackWrapper>
          <Loader />
        </FeedbackWrapper>
      )}
      {submitError && (
        <FeedbackWrapper>
          <ErrorMessage error={submitError} />
        </FeedbackWrapper>
      )}
      {!hideExisting && examsResult?.hasPassedCourse && (
        <span>{intl.formatMessage({ id: 'competenceDashboard.educatia.registered' })}</span>
      )}
      {examsResult?.url && (
        <SdirButton
          text={intl.formatMessage({ id: 'competenceDashboard.educatia.current' })}
          onClick={onOpenExistingExam}
          type="primary"
          id="existing-educatia-exam"
        />
      )}
      {!examsResult && (
        <SdirButton
          text={intl.formatMessage({ id: 'competenceDashboard.educatia.new' })}
          onClick={onNewExam}
          type="primary"
          id="new-educatia-exam"
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 40px;
  margin-top: 20px;

  #new-educatia-exam {
    max-width: 220px;
  }
  #existing-educatia-exam {
    width: fit-content;
  }
`;

const FeedbackWrapper = styled.div`
  margin: 15px 0;
`;
